export enum ISO_LOCALE {
	ENGLISH = 'en-US',
	UKRAINIAN = 'uk-UA'
}